<template>
  <div>
    <!-- Header -->
    <b-modal v-model="modalShow" ok-only centered class="text-center text-info">
      You are not logged in as a user!
    </b-modal>
    <b-modal
      v-model="modalShow1"
      ok-only
      centered
      class="text-center text-info"
    >
      You can't add more shops to My SHOPiN!
    </b-modal>
    <b-modal
      v-model="modalShow2"
      ok-only
      centered
      class="text-center text-info"
    >
      Shop is added to My SHOPiN.
    </b-modal>
    <header class="header-v4">
      <!-- Header desktop -->
      <div class="container-menu-desktop">
        <!-- Topbar -->
        <div class="top-bar">
          <div class="content-topbar flex-sb-m h-full container">
            <div class="left-top-bar">
              <router-link class="logo" to="/">
                <img
                  src="../../../static/img/logo/Logo2.jpeg"
                  alt="eshops-logo" width="40" height="40"
                />
              </router-link>

              <!-- Free shipping for standard order over $100 -->
            </div>

            <div class="right-top-bar flex-w h-full">
              <router-link
                :to="{ name: 'home' }"
                class="flex-c-m trans-04 p-lr-25"
              >
                Home
              </router-link>
              <!-- <router-link :to="{name: 'regshop', params:{plan: 'Premium'}}" class="flex-c-m trans-04 p-lr-25">
							Create Store
						</router-link> -->
              <router-link
                :to="{ name: 'search', query: searchQuery }"
                class="flex-c-m trans-04 p-lr-25"
                v-if="
                  this.$store.state.searchLocation != undefined &&
                  this.$store.state.searchLocation != ''
                "
              >
                Back to Search
              </router-link>
              <router-link
                style="color: red"
                :to="{ name: adminLink }"
                v-if="admin"
                class="flex-c-m trans-04 p-lr-25"
              >
                Admin Area
              </router-link>
              <router-link
                style="color: red"
                :to="{ name: 'admin-services' }"
                v-if="pageadmin"
                class="flex-c-m trans-04 p-lr-25"
              >
                Admin Area
              </router-link>
              <router-link
                :to="{ name: 'signin' }"
                v-if="visitor"
                class="flex-c-m trans-04 p-lr-25"
              >
                Sign in
              </router-link>

              <router-link
                :to="{ name: 'usersignup' }"
                v-if="visitor"
                class="flex-c-m trans-04 p-lr-25"
              >
                Sign up
              </router-link>
              <router-link
                :to="{ name: 'myaccount' }"
                v-if="user"
                class="flex-c-m trans-04 p-lr-25"
              >
                My Account
              </router-link>
              <a
                style="cursor: pointer; color: red"
                @click="logout()"
                v-if="user || admin || pageadmin"
                class="flex-c-m trans-04 p-lr-25"
                >Sign out</a
              >
            </div>
          </div>
        </div>

        <div class="wrap-menu-desktop how-shadow1">
          <nav class="limiter-menu-desktop container">
            <!-- Logo desktop -->
            <!-- <a href="#" class="logo">
						<img src="images/icons/logo-01.png" alt="IMG-LOGO">
					</a> -->

            <!-- Menu desktop -->
            <div class="menu-desktop">
              <ul class="main-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'storehome',
                      params: { storename: this.$route.params.storename },
                    }"
                    >Home</router-link
                  >
                </li>

                <!-- <li>
								<a>Products</a>
								<ul class="sub-menu">
									<li v-for="(hh, category) in categoriesList" :key="category"><router-link  :to="{name: 'storeproducts', query: {cat: category}}">{{category}}</router-link></li>
									
								</ul>
							</li> -->

                <li v-if="plan != 'Starter'">
                  <router-link
                    :to="{
                      name: 'storecategories',
                      params: { storename: this.$route.params.storename },
                    }"
                    >Categories</router-link
                  >
                </li>

                <li>
                  <router-link
                    :to="{
                      name: 'storeoffers',
                      params: { storename: this.$route.params.storename },
                    }"
                    >Offers</router-link
                  >
                </li>

                <!-- <li>
								<router-link :to="{name: 'storeabout', params:{storename: this.$route.params.storename}}">About</router-link>
							</li> -->

                <li>
                  <router-link
                    :to="{
                      name: 'storecontact',
                      params: { storename: this.$route.params.storename },
                    }"
                    >Contact</router-link
                  >
                </li>
              </ul>
            </div>

            <!-- Icon header -->
            <div class="wrap-icon-header flex-w flex-r-m">
              <div
                class="icon-header-item cl2 hov-cl1 trans-04 tooltip100"
                :data-tooltip="this.datanotify"
              >
                <i
                  class="fa fa-heart-o"
                  v-if="isFavShop == undefined || isFavShop == 'show'"
                  @click="addToFavourite()"
                ></i>
                <i
                  class="fa fa-heart-o text-danger"
                  v-if="isFavourite == true"
                  style="cursor: default"
                ></i>
              </div>
              <div
                class="icon-header-item cl2 hov-cl1 trans-04 p-l-22 p-r-11"
                style="cursor: pointer"
              >
                <i class="fa fa-share-alt" @click="share()"></i>
              </div>
              <div
                class="
                  icon-header-item
                  cl2
                  hov-cl1
                  trans-04
                  p-r-11 p-l-10
                  icon-header-noti
                "
                :data-notify="cartItems"
                
              >
                <i class="fa fa-shopping-cart" @click="cartClicked()"></i>
                <!-- <router-link :to="{name: 'storecart', params:{storename: this.$route.params.storename}}"  v-if="cartlink"></router-link> -->
              </div>
            </div>
          </nav>
        </div>
      </div>

      <!-- Header Mobile -->
      <div class="wrap-header-mobile" style="">
        <!-- Logo moblie -->
        <div class="logo-mobile">
          <router-link class="ml-2" to="/">
            <img
              src="../../../static/img/logo/Logo2.jpeg"
              alt="eshops-logo"
            />
          </router-link>
        </div>

        <!-- Icon header -->
        <div class="wrap-icon-header flex-w flex-r-m" style="">
          <div class="icon-header-item cl2 hov-cl1 trans-04">
            <i
              class="fa fa-heart-o"
              v-if="isFavShop == undefined || isFavShop == 'show'"
              @click="addToFavourite()"
              style="font-size: 25px"
            ></i>
            <i
              class="fa fa-heart-o text-danger"
              v-if="isFavourite == true"
              style="cursor: default; font-size: 25px"
            ></i>
          </div>
          <div
            class="icon-header-item cl2 hov-cl1 trans-04 p-l-22 p-r-11"
            style="cursor: pointer"
          >
            <i
              class="fa fa-share-alt"
              style="font-size: 25px"
              @click="share()"
            ></i>
          </div>
          <div
            class="
              icon-header-item
              cl2
              hov-cl1
              trans-04
              p-r-11 p-l-10
              icon-header-noti
            "
            :data-notify="cartItems"
            
          >
            <i
              class="fa fa-shopping-cart"
              style="font-size: 30px"
              @click="cartClicked()"
            ></i>
          </div>
          <div class="icon-header-item cl2 trans-04 p-r-11 p-l-10">
            <i
              class="fa fa-bars hamburger-inner"
              style="font-size: 25px"
              @click="showsidemenu = true"
            ></i>
          </div>
        </div>

        <!-- Button show menu -->
        <!-- <div class="btn-show-menu-mobile hamburger js-show-cart">
				<span class="hamburger-box">
				
				</span>
			</div> -->
      </div>

      <!-- Menu Mobile -->
      <div class="wrap-header-cart js-panel-cart">
        <div class="s-full js-hide-cart"></div>

        <!-- <div class="header-cart flex-col-l p-l-65 p-r-25">
		
			<ul class="topbar-mobile">
				<li>
					<div class="left-top-bar">
						Free shipping for standard order over $100
					</div>
				</li>

				<li>
					<div class="right-top-bar flex-w h-full">
						<a href="#" class="flex-c-m p-lr-10 trans-04">
							Help & FAQs
						</a>

						<a href="#" class="flex-c-m p-lr-10 trans-04">
							My Account
						</a>

						<a href="#" class="flex-c-m p-lr-10 trans-04">
							EN
						</a>

						<a href="#" class="flex-c-m p-lr-10 trans-04">
							USD
						</a>
					</div>
				</li>
			</ul>

			<ul class="main-menu-m">
				<li>
					<a href="product.html">Home</a>
				</li>

				<li>
					<router-link :to="{name: 'search', query: {cat: cat, loc: loc}}">Search</router-link>
				</li>

				<li>
					<a>Products</a>
					<ul class="sub-menu-m">
									<li v-for="(hh, category) in categoriesList" :key="category"><router-link  :to="{name: 'storeproducts', query: {cat: category}}">{{category}}</router-link></li>
									
								</ul>
					<span class="arrow-main-menu-m">
						<i class="fa fa-angle-right" aria-hidden="true"></i>
					</span>
				</li>

				<li>
					<a href="shoping-cart.html" class="label1 rs1" data-label1="hot">Features</a>
				</li>

				<li>
					<router-link :to="{name: 'storecategories', params:{storename: this.$route.params.storename}}">Categories</router-link>
				</li>

				<li>
					<a href="about.html">About</a>
				</li>

				<li>
					<a href="contact.html">Contact</a>
				</li>
			</ul>
		
		</div> -->
      </div>
      <!-- Modal Search -->
      <!-- <div class="modal-search-header flex-c-m trans-04 js-hide-modal-search">
			<div class="container-search-header">
				<button class="flex-c-m btn-hide-modal-search trans-04 js-hide-modal-search">
					<img src="images/icons/icon-close2.png" alt="CLOSE">
				</button>

				<form class="wrap-search-header flex-w p-l-15">
					<button class="flex-c-m trans-04">
						<i class="zmdi zmdi-search"></i>
					</button>
					<input class="plh3" type="text" name="search" placeholder="Search...">
				</form>
			</div>
		</div> -->
    </header>

    <!-- Cart -->
    <div
      class="wrap-header-cart js-panel-cart"
      :class="{ 'show-header-cart': showsidemenu }"
    >
      <div class="s-full js-hide-cart" @click="showsidemenu = false"></div>

      <div class="header-cart">
        <div class="header-cart-title flex-w flex-sb-m p-b-8">
          <div class="logo-mobile">
            <a href=""
              ><img src="../../../static/img/logo/Logo2.jpeg" alt="IMG-LOGO"
            /></a>
          </div>

          <div
            class="fs-35 lh-10 p-lr-5 pointer hov-cl1 trans-04 js-hide-cart"
            @click="showsidemenu = false"
          >
            <i class="fa fa-close text-white"></i>
          </div>
        </div>

        <div
          class="header-cart-content js-pscroll m-slide-h"
          style="height: 440px"
        >
          <ul class="main-menu-m">
            <li @click="showsidemenu = false">
              <router-link
                :to="{
                  name: 'storehome',
                  params: { storename: this.$route.params.storename },
                }"
                >Store Home</router-link
              >
            </li>

            <li v-if="plan != 'Starter'" @click="showsidemenu = false">
              <router-link
                :to="{
                  name: 'storecategories',
                  params: { storename: this.$route.params.storename },
                }"
                >Store Categories</router-link
              >
            </li>

            <li @click="showsidemenu = false">
              <router-link
                :to="{
                  name: 'storeoffers',
                  params: { storename: this.$route.params.storename },
                }"
                >Store Offers</router-link
              >
            </li>

            <!-- <li @click="showsidemenu = false">
					<router-link :to="{name: 'storeabout', params:{storename: this.$route.params.storename}}">Store About</router-link>
				</li> -->

            <li @click="showsidemenu = false">
              <router-link
                :to="{
                  name: 'storecontact',
                  params: { storename: this.$route.params.storename },
                }"
                >Store Contact</router-link
              >
            </li>
            <hr />
            <li @click="showsidemenu = false">
              <router-link :to="{ name: 'home' }" class=""> Home </router-link>
            </li>
            <!-- <li @click="showsidemenu = false"><router-link :to="{name: 'regshop', params:{plan: 'Premium'}}" class=" ">
							Create Store
						</router-link>
					</li> -->
            <li @click="showsidemenu = false">
              <router-link
                :to="{ name: 'search', query: searchQuery }"
                class=""
                v-if="
                  this.$store.state.searchLocation != undefined &&
                  this.$store.state.searchLocation != ''
                "
              >
                Back to Search
              </router-link>
            </li>
            <li @click="showsidemenu = false">
              <router-link :to="{ name: adminLink }" v-if="admin" class="">
                Admin Area
              </router-link>
            </li>
            <li @click="showsidemenu = false">
              <router-link
                :to="{ name: 'admin-services' }"
                v-if="pageadmin"
                class=""
              >
                Admin Area
              </router-link>
            </li>
            <li @click="showsidemenu = false">
              <router-link :to="{ name: 'signin' }" v-if="visitor">
                Sign in
              </router-link>
            </li>
            <li @click="showsidemenu = false">
              <router-link :to="{ name: 'usersignup' }" v-if="visitor">
                Sign up
              </router-link>
            </li>
            <li @click="showsidemenu = false">
              <router-link :to="{ name: 'myaccount' }" v-if="user">
                My Account
              </router-link>
            </li>
            <li @click="showsidemenu = false">
              <a
                style="cursor: pointer"
                @click="logout()"
                v-if="user || admin || pageadmin"
              >
                Sign out
              </a>
            </li>
          </ul>
          <!-- <ul class="header-cart-wrapitem w-full">
					<li class="header-cart-item flex-w flex-t m-b-12">
						<div class="header-cart-item-img">
							<img src="images/item-cart-01.jpg" alt="IMG">
						</div>

						<div class="header-cart-item-txt p-t-8">
							<a href="#" class="header-cart-item-name m-b-18 hov-cl1 trans-04">
								White Shirt Pleat
							</a>

							<span class="header-cart-item-info">
								1 x $19.00
							</span>
						</div>
					</li>

					<li class="header-cart-item flex-w flex-t m-b-12">
						<div class="header-cart-item-img">
							<img src="images/item-cart-02.jpg" alt="IMG">
						</div>

						<div class="header-cart-item-txt p-t-8">
							<a href="#" class="header-cart-item-name m-b-18 hov-cl1 trans-04">
								Converse All Star
							</a>

							<span class="header-cart-item-info">
								1 x $39.00
							</span>
						</div>
					</li>

					<li class="header-cart-item flex-w flex-t m-b-12">
						<div class="header-cart-item-img">
							<img src="images/item-cart-03.jpg" alt="IMG">
						</div>

						<div class="header-cart-item-txt p-t-8">
							<a href="#" class="header-cart-item-name m-b-18 hov-cl1 trans-04">
								Nixon Porter Leather
							</a>

							<span class="header-cart-item-info">
								1 x $17.00
							</span>
						</div>
					</li>
				</ul>
				
				<div class="w-full">
					<div class="header-cart-total w-full p-tb-40">
						Total: $75.00
					</div>

					<div class="header-cart-buttons flex-w w-full">
						<router-link :to="{name: 'storecart', params:{storename: this.$route.params.storename}}" class="flex-c-m stext-101 cl0 size-107 bg3 bor2 hov-btn3 p-lr-15 trans-04 m-r-8 m-b-10">
							View Cart
						</router-link>

						<a href="shoping-cart.html" class="flex-c-m stext-101 cl0 size-107 bg3 bor2 hov-btn3 p-lr-15 trans-04 m-b-10">
							Check Out
						</a>
					</div>
				</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import { bus } from "../../main";
// require('../../assets/store/vendor/jquery/jquery-3.2.1.min.js')
// import '../../assets/store/vendor/animsition/js/animsition.min.js'
import mobiles from "../../data/mobiles";
import ClothingAccessories from "../../data/ClothingAccessories";

export default {
  name: "navbar",
  data() {
    return {
      modalShow: false,
      modalShow1: false,
      modalShow2: false,
      showsidemenu: false,
      categoriesList: [],
      shops: [],
      favshops: [],
      isFavShop: "show",
      isFavourite: false,
      isLoggedIn: false,
      visits: "",
      loc: "",
      cat: "",
      param: "",
      searchQuery: {},
      plan: "",
      cartItems: 0,
      homeimg: "",
      filesArray: [],
      user: false,
      admin: false,
      pageadmin: false,
      visitor: false,
      datanotify: "Add to My SHOPiN",
      shopcats: {},
      shopname: "",
      fullPath: "",
      adminLink: 'admin',
    };
  },
  // props: ['categoriesList'],
  watch: {
    shops() {
      if (this.shops[0].shoptype == "Fashion") {
        this.categoriesList = ClothingAccessories;
      }
      if (this.shops[0].shoptype == "Elec") {
        this.categoriesList = mobiles;
      }
    },
  },
  methods: {
    share() {
      if (navigator.share) {
        navigator
          .share({
            title: this.shopname,
            text: this.$route.meta.title,
            url: "https://eshops.lk/#" + this.$route.fullPath,
          })
          .then(() => {
            alert("Successful share");
          })
          .catch((error) => {
            alert("Error sharing " + error);
          });
      } else {
        var url = "https://eshops.lk/#" + this.$route.fullPath;
        alert(
          "Web Share is not supported by this browser. You can copy this link and share it. Link - " +
            url
        );
      }
    },
    addToFavourite() {
      if (!firebase.auth().currentUser) {
        this.modalShow = true;
      }
      if (firebase.auth().currentUser) {
        // if(firebase.auth().currentUser.displayName == 'shop owner'){
        // 	this.modalShow = true
        // }else{
        if (this.favshops[0].favshops.length <= 25) {
          this.favshops[0].favshops.push(
            this.$store.state.shops[this.$route.params.storename].id
          );
          //console.log('favsp updated', this.favshops[0].favshops)
          this.isFavShop =
            this.$store.state.shops[this.$route.params.storename].id;
          this.isFavourite = true;
          this.datanotify = "Added to My SHOPiN";
          this.modalShow2 = true;
          db.collection("users")
            .doc(this.favshops[0].docid)
            .update({
              favshops: this.favshops[0].favshops,
            })
            .then(() => {
              //console.log('')
            })
            .catch((error) => {
              //console.log('error',error)
            });
        } else {
          this.modalShow1 = true;
        }
        //}
      }
      // else if(firebase.auth().currentUser && !firebase.auth().currentUser.emailVerified){
      // 	this.modalShow = true
      // }
    },

    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push("/");
        });
    },
    cartClicked() {
      if (this.visitor) {
        this.modalShow = true;
      } else if (this.user || this.admin || this.pageadmin) {
        this.cartlink = true;
        this.$router.push({
          name: "storecart",
          params: { storename: this.$route.params.storename },
        });
      }
    },
  },
  created() {
    //console.log(this.$route.meta.title)
    this.fullPath = this.$route.fullPath;
    bus.$on("cartChanged", (data) => {
      this.cartItems = data;
    });

    if (firebase.auth().currentUser) {
      if (this.$store.state.systemUser.role === "Cashier" || this.$store.state.systemUser.role === 'Shop Manager')
        this.adminLink = 'createinvoice'
      else if (this.$store.state.systemUser.role === "Kitchen Staff" || this.$store.state.systemUser.role === "Service Staff")
        this.adminLink = 'kot'
      if (firebase.auth().currentUser.displayName == null) {
        this.user = true;
      } else if (
        firebase.auth().currentUser.displayName == "shop owner" ||
        firebase.auth().currentUser.displayName == "starterplan shop owner"
      ) {
        this.admin = true;
      } else if (firebase.auth().currentUser.displayName == "page owner") {
        this.pageadmin = true;
      }
    } else {
      this.visitor = true;
    }
    // if(firebase.auth().currentUser){
    // if(firebase.auth().currentUser.displayName != 'shop owner'){
    // 	this.isLoggedIn = true
    // }
    // }
    //console.log("this.shops[0].shoptype")
    if (this.$store.state.shops[this.$route.params.storename] != undefined) {
      //  var secondaryAppConfig = this.$store.state.shops[this.$route.params.storename].config
      //  if(firebase.app().name != this.$store.state.shops[this.$route.params.storename].id){
      //  this.$store.state.secondaryApp = firebase.initializeApp(secondaryAppConfig, this.$store.state.shops[this.$route.params.storename].id)
      //  this.$store.state.secondaryDatabase = secondary.firestore()
      //  }
      //  console.log('secondaryDB', this.$store.state.secondaryDatabase)

      this.shopcats =
        this.$store.state.shops[this.$route.params.storename].categories;
      this.visits =
        this.$store.state.shops[this.$route.params.storename].visits;
      // this.loc = this.shops[0].loc
      this.cat = this.$store.state.shops[this.$route.params.storename].cat;
      this.plan = this.$store.state.shops[this.$route.params.storename].plan;
      this.shopname =
        this.$store.state.shops[this.$route.params.storename].name;
      if (
        this.$store.state.shops[this.$route.params.storename].homeimg !=
        undefined
      ) {
        this.homeimg =
          this.$store.state.shops[this.$route.params.storename].homeimg;
        this.filesArray.push(this.homeimg);
        //console.log('ary is', this.filesArray)
      } else {
        this.homeimg = "../../../static/images/ecommerce.jpg";
        this.filesArray.push(this.homeimg);
        //console.log('ary is', this.filesArray)
      }
      //console.log('cat is', this.cat)
      //console.log('this.$store.state.shops[this.$route.params.storename] is', this.$store.state.shops[this.$route.params.storename])

      this.loc = this.$store.state.searchLocation;

      this.searchQuery["cat"] = this.cat;
      this.searchQuery["loc"] = this.loc;
    } else {
      db.collection("shops")
        .where("owner", "==", this.$route.params.storename)
        .onSnapshot((querySnapshot) => {
          this.shops = [];
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              name: doc.data().name,
              shoptype: doc.data().shoptype,
              visits: doc.data().visits,
              loc: doc.data().location,
              categories: doc.data().categories,
              homeimg: doc.data().homeimg,
              plan: doc.data().plan,
              cat: doc.data().cat,
              details: doc.data().details,
              config: doc.data().config,
            };
            this.shops.push(data);
            //console.log(this.shops[0].config)
            //console.log(this.shops[0].id)
            // var secondaryAppConfig = this.shops[0].config
            // var secondary = firebase.initializeApp(secondaryAppConfig, this.$route.params.storename)
            // this.$store.state.secondaryDatabase = secondary.firestore()
            // this.$store.state.secondaryApp = this.$route.params.storename
            // this.$store.state.secondaryDatabase.settings({timestampsInSnapshots: true,})
            // this.$store.state.secondaryDatabase.enablePersistence({experimentalTabSynchronization:true}).then(() => {
            // 	//console.log("Woohoo! Multi-Tab Persistence!");
            // });
            // console.log('secondaryDB', this.$store.state.secondaryDatabase)

            this.shopcats = this.shops[0].categories;
            this.visits = this.shops[0].visits;
            // this.loc = this.shops[0].loc
            this.cat = this.shops[0].cat;
            this.plan = this.shops[0].plan;
            this.shopname = this.shops[0].name;
            if (this.shops[0].homeimg != undefined) {
              this.homeimg = this.shops[0].homeimg;
              this.filesArray.push(this.homeimg);
              //console.log('ary is', this.filesArray)
            } else {
              this.homeimg = "../../../static/images/ecommerce.jpg";
              this.filesArray.push(this.homeimg);
              //console.log('ary is', this.filesArray)
            }
            //console.log('cat is', this.cat)
            //console.log('cat is', this.shops[0].cat)
            this.$store.state.shops[this.$route.params.storename] =
              this.shops[0];
            //console.log('cat is', this.$store.state.shops[this.$route.params.storename])
            this.loc = this.$store.state.searchLocation;

            this.searchQuery["cat"] = this.cat;
            this.searchQuery["loc"] = this.loc;
          });
        });
    }
    //   beforeCreate(){

    if (firebase.auth().currentUser) {
      // if(firebase.auth().currentUser.displayName != 'shop owner'){
      db.collection("users")
        .where("uid", "==", firebase.auth().currentUser.uid)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              favshops: doc.data().favshops,
              docid: doc.id,
            };
            this.favshops.push(data);
            //console.log('favshops',this.favshops)
          });
          var findFavShop = function (fshops, id) {
            var findedid = fshops.find((fs, index) => {
              return fs == id;
            });
            return findedid;
          };
          this.isFavShop = findFavShop(
            this.favshops[0].favshops,
            this.$store.state.shops[this.$route.params.storename].id
          );
          //console.log('isFavShop',this.isFavShop)
          if (
            this.isFavShop ==
            this.$store.state.shops[this.$route.params.storename].id
          ) {
            this.isFavourite = true;
            this.datanotify = "Added to My SHOPiN";
          }
        });

      //console.log('cartitems',this.$store.state.cartItems[this.$route.params.storename])
      if (
        this.$store.state.cartItems[this.$route.params.storename] != undefined
      ) {
        this.cartItems =
          this.$store.state.cartItems[this.$route.params.storename];
        //console.log('Store cartItems',this.cartItems)
      } else {
        var cartitems = [];
        var foreachRun = false;
        this.$store.state.secondaryDatabase
          .collection("carts")
          .where("uid", "==", firebase.auth().currentUser.uid)
          .where("shopid", "==", this.$route.params.storename)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const data = {};
              foreachRun = true;
              cartitems.push(data);
              //console.log('cartitems',cartitems)
              this.cartItems = cartitems.length;
              this.$store.state.cartItems[this.$route.params.storename] =
                cartitems.length;
              //console.log('this.cartItems',this.cartItems)
            });
            //console.log('cartitems',cartitems)
            if (foreachRun == false) {
              this.$store.state.cartItems[this.$route.params.storename] = 0;
            }
          });
      }
    }
    // 		    this.$nextTick(() => {
    //   //   $('.header-v4').hide();
    //   /*==================================================================
    //     [ Fixed Header ]*/
    //     var headerDesktop = $('.container-menu-desktop');
    //     var wrapMenu = $('.wrap-menu-desktop');

    //     if($('.top-bar').length > 0) {
    //         var posWrapHeader = $('.top-bar').height();
    //     }
    //     else {
    //         var posWrapHeader = 0;
    //     }

    //     if($(window).scrollTop() > posWrapHeader) {
    //         $(headerDesktop).addClass('fix-menu-desktop');
    //         $(wrapMenu).css('top',0);
    //     }
    //     else {
    //         $(headerDesktop).removeClass('fix-menu-desktop');
    //         $(wrapMenu).css('top',posWrapHeader - $(this).scrollTop());
    //     }

    //     $(window).on('scroll',function(){
    //         if($(this).scrollTop() > posWrapHeader) {
    //             $(headerDesktop).addClass('fix-menu-desktop');
    //             $(wrapMenu).css('top',0);
    //         }
    //         else {
    //             $(headerDesktop).removeClass('fix-menu-desktop');
    //             $(wrapMenu).css('top',posWrapHeader - $(this).scrollTop());
    //         }
    //     });

    //     /*==================================================================
    //     [ Menu mobile ]*/
    // 	$('.btn-show-menu-mobile').on('click', function(){
    //         $(this).toggleClass('is-active');
    //         $('.menu-mobile').slideToggle();
    //     });

    //     var arrowMainMenu = $('.arrow-main-menu-m');

    //     for(var i=0; i<arrowMainMenu.length; i++){
    //         $(arrowMainMenu[i]).on('click', function(){
    //             $(this).parent().find('.sub-menu-m').slideToggle();
    //             $(this).toggleClass('turn-arrow-main-menu-m');
    //         })
    //     }

    //     $(window).resize(function(){
    //         if($(window).width() >= 992){
    //             if($('.menu-mobile').css('display') == 'block') {
    //                 $('.menu-mobile').css('display','none');
    //                 $('.btn-show-menu-mobile').toggleClass('is-active');
    //             }

    //             $('.sub-menu-m').each(function(){
    //                 if($(this).css('display') == 'block') {
    //                     //console.log('hello');
    //                     $(this).css('display','none');
    //                     $(arrowMainMenu).removeClass('turn-arrow-main-menu-m');
    //                 }
    //             });

    //         }
    //   });

    //   /*==================================================================
    //     [ Isotope ]*/
    //     var $topeContainer = $('.isotope-grid');
    //     var $filter = $('.filter-tope-group');

    //     // filter items on button click
    //     $filter.each(function () {
    //         $filter.on('click', 'button', function () {
    //             var filterValue = $(this).attr('data-filter');
    //             $topeContainer.isotope({filter: filterValue});
    //         });

    //     });

    //     // init Isotope
    //     $(window).on('load', function () {
    //         var $grid = $topeContainer.each(function () {
    //             $(this).isotope({
    //                 itemSelector: '.isotope-item',
    //                 layoutMode: 'fitRows',
    //                 percentPosition: true,
    //                 animationEngine : 'best-available',
    //                 masonry: {
    //                     columnWidth: '.isotope-item'
    //                 }
    //             });
    //         });
    //     });

    //     var isotopeButton = $('.filter-tope-group button');

    //     $(isotopeButton).each(function(){
    //         $(this).on('click', function(){
    //             for(var i=0; i<isotopeButton.length; i++) {
    //                 $(isotopeButton[i]).removeClass('how-active1');
    //             }

    //             $(this).addClass('how-active1');
    //         });
    //     });

    //     /*==================================================================
    //     [ Filter / Search product ]*/
    //     $('.js-show-filter').on('click',function(){
    //         $(this).toggleClass('show-filter');
    //         $('.panel-filter').slideToggle(400);

    //         if($('.js-show-search').hasClass('show-search')) {
    //             $('.js-show-search').removeClass('show-search');
    //             $('.panel-search').slideUp(400);
    //         }
    //     });

    //     $('.js-show-search').on('click',function(){
    //         $(this).toggleClass('show-search');
    //         $('.panel-search').slideToggle(400);

    //         if($('.js-show-filter').hasClass('show-filter')) {
    //             $('.js-show-filter').removeClass('show-filter');
    //             $('.panel-filter').slideUp(400);
    //         }
    //     });

    // 	 /*==================================================================
    //     [ Cart ]*/
    //     $('.js-show-cart').on('click',function(){
    //         $('.js-panel-cart').addClass('show-header-cart');
    //     });

    //     $('.js-hide-cart').on('click',function(){
    //         $('.js-panel-cart').removeClass('show-header-cart');
    //     });

    //     /*==================================================================
    //     [ Cart ]*/
    //     $('.js-show-sidebar').on('click',function(){
    //         $('.js-sidebar').addClass('show-sidebar');
    //     });

    //     $('.js-hide-sidebar').on('click',function(){
    //         $('.js-sidebar').removeClass('show-sidebar');
    // 	});

    // 	 /*==================================================================
    //     [ Show / hide modal search ]*/
    //     $('.js-show-modal-search').on('click', function(){
    //         $('.modal-search-header').addClass('show-modal-search');
    //         $(this).css('opacity','0');
    //     });

    //     $('.js-hide-modal-search').on('click', function(){
    //         $('.modal-search-header').removeClass('show-modal-search');
    //         $('.js-show-modal-search').css('opacity','1');
    //     });

    //     $('.container-search-header').on('click', function(e){
    //         e.stopPropagation();
    //     });

    //      /*==================================================================
    //     [ +/- num product ]*/
    //     $('.btn-num-product-down').on('click', function(){
    //         var numProduct = Number($(this).next().val());
    //         if(numProduct > 0) $(this).next().val(numProduct - 1);
    //     });

    //     $('.btn-num-product-up').on('click', function(){
    //         var numProduct = Number($(this).prev().val());
    //         $(this).prev().val(numProduct + 1);
    //     });

    //     /*==================================================================
    //     [ Rating ]*/
    //     $('.wrap-rating').each(function(){
    //         var item = $(this).find('.item-rating');
    //         var rated = -1;
    //         var input = $(this).find('input');
    //         $(input).val(0);

    //         $(item).on('mouseenter', function(){
    //             var index = item.index(this);
    //             var i = 0;
    //             for(i=0; i<=index; i++) {
    //                 $(item[i]).removeClass('zmdi-star-outline');
    //                 $(item[i]).addClass('zmdi-star');
    //             }

    //             for(var j=i; j<item.length; j++) {
    //                 $(item[j]).addClass('zmdi-star-outline');
    //                 $(item[j]).removeClass('zmdi-star');
    //             }
    //         });

    //         $(item).on('click', function(){
    //             var index = item.index(this);
    //             rated = index;
    //             $(input).val(index+1);
    //         });

    //         $(this).on('mouseleave', function(){
    //             var i = 0;
    //             for(i=0; i<=rated; i++) {
    //                 $(item[i]).removeClass('zmdi-star-outline');
    //                 $(item[i]).addClass('zmdi-star');
    //             }

    //             for(var j=i; j<item.length; j++) {
    //                 $(item[j]).addClass('zmdi-star-outline');
    //                 $(item[j]).removeClass('zmdi-star');
    //             }
    //         });
    //     });

    //     /*==================================================================
    //     [ Show modal1 ]*/
    //     $('.js-show-modal1').on('click',function(e){
    //         e.preventDefault();
    //         $('.js-modal1').addClass('show-modal1');
    //     });

    //     $('.js-hide-modal1').on('click',function(){
    //         $('.js-modal1').removeClass('show-modal1');
    //     });

    //      /*[ Back to top ]
    //     ===========================================================*/
    //     var windowH = $(window).height()/2;

    //     $(window).on('scroll',function(){
    //         if ($(this).scrollTop() > windowH) {
    //             $("#myBtn").css('display','flex');
    //         } else {
    //             $("#myBtn").css('display','none');
    //         }
    //     });

    //     $('#myBtn').on("click", function(){
    //         $('html, body').animate({scrollTop: 0}, 300);
    //     });

    //     /***********Slick js *********************/

    // (function ($) {
    //     // USE STRICT
    //     "use strict";

    //         /*==================================================================
    //         [ Slick1 ]*/
    //         $('.wrap-slick1').each(function(){
    //             var wrapSlick1 = $(this);
    //             var slick1 = $(this).find('.slick1');

    //             var itemSlick1 = $(slick1).find('.item-slick1');
    //             var layerSlick1 = $(slick1).find('.layer-slick1');
    //             var actionSlick1 = [];

    //             $(slick1).on('init', function(){
    //                 var layerCurrentItem = $(itemSlick1[0]).find('.layer-slick1');

    //                 for(var i=0; i<actionSlick1.length; i++) {
    //                     clearTimeout(actionSlick1[i]);
    //                 }

    //                 $(layerSlick1).each(function(){
    //                     $(this).removeClass($(this).data('appear') + ' visible-true');
    //                 });

    //                 for(var i=0; i<layerCurrentItem.length; i++) {
    //                     actionSlick1[i] = setTimeout(function(index) {
    //                         $(layerCurrentItem[index]).addClass($(layerCurrentItem[index]).data('appear') + ' visible-true');
    //                     },$(layerCurrentItem[i]).data('delay'),i);
    //                 }
    //             });

    //             var showDot = false;
    //             if($(wrapSlick1).find('.wrap-slick1-dots').length > 0) {
    //                 showDot = true;
    //             }

    //             $(slick1).slick({
    //                 pauseOnFocus: false,
    //                 pauseOnHover: false,
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //                 fade: true,
    //                 speed: 1000,
    //                 infinite: true,
    //                 autoplay: true,
    //                 autoplaySpeed: 6000,
    //                 arrows: true,
    //                 appendArrows: $(wrapSlick1),
    //                 prevArrow:'<button class="arrow-slick1 prev-slick1"><i class="zmdi zmdi-caret-left"></i></button>',
    //                 nextArrow:'<button class="arrow-slick1 next-slick1"><i class="zmdi zmdi-caret-right"></i></button>',
    //                 dots: showDot,
    //                 appendDots: $(wrapSlick1).find('.wrap-slick1-dots'),
    //                 dotsClass:'slick1-dots',
    //                 customPaging: function(slick, index) {
    //                     var linkThumb = $(slick.$slides[index]).data('thumb');
    //                     var caption = $(slick.$slides[index]).data('caption');
    //                     return  '<img src="' + linkThumb + '">' +
    //                             '<span class="caption-dots-slick1">' + caption + '</span>';
    //                 },
    //             });

    //             $(slick1).on('afterChange', function(event, slick, currentSlide){

    //                 var layerCurrentItem = $(itemSlick1[currentSlide]).find('.layer-slick1');

    //                 for(var i=0; i<actionSlick1.length; i++) {
    //                     clearTimeout(actionSlick1[i]);
    //                 }

    //                 $(layerSlick1).each(function(){
    //                     $(this).removeClass($(this).data('appear') + ' visible-true');
    //                 });

    //                 for(var i=0; i<layerCurrentItem.length; i++) {
    //                     actionSlick1[i] = setTimeout(function(index) {
    //                         $(layerCurrentItem[index]).addClass($(layerCurrentItem[index]).data('appear') + ' visible-true');
    //                     },$(layerCurrentItem[i]).data('delay'),i);
    //                 }

    //             });

    //         });

    //         /*==================================================================
    //         [ Slick2 ]*/
    //         $('.wrap-slick2').each(function(){
    //             $(this).find('.slick2').slick({
    //               slidesToShow: 4,
    //               slidesToScroll: 4,
    //               infinite: false,
    //               autoplay: false,
    //               autoplaySpeed: 6000,
    //               arrows: true,
    //               appendArrows: $(this),
    //               prevArrow:'<button class="arrow-slick2 prev-slick2"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    //               nextArrow:'<button class="arrow-slick2 next-slick2"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    //               responsive: [
    //                 {
    //                   breakpoint: 1200,
    //                   settings: {
    //                     slidesToShow: 4,
    //                     slidesToScroll: 4
    //                   }
    //                 },
    //                 {
    //                   breakpoint: 992,
    //                   settings: {
    //                     slidesToShow: 3,
    //                     slidesToScroll: 3
    //                   }
    //                 },
    //                 {
    //                   breakpoint: 768,
    //                   settings: {
    //                     slidesToShow: 2,
    //                     slidesToScroll: 2
    //                   }
    //                 },
    //                 {
    //                   breakpoint: 576,
    //                   settings: {
    //                     slidesToShow: 1,
    //                     slidesToScroll: 1
    //                   }
    //                 }
    //               ]
    //             });
    //           });

    //         $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    //           var nameTab = $(e.target).attr('href');
    //           $(nameTab).find('.slick2').slick('reinit');
    //         });

    //         /*==================================================================
    //         [ Slick3 ]*/
    //         $('.wrap-slick3').each(function(){
    //             $(this).find('.slick3').slick({
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //                 fade: true,
    //                 infinite: true,
    //                 autoplay: false,
    //                 autoplaySpeed: 6000,

    //                 arrows: true,
    //                 appendArrows: $(this).find('.wrap-slick3-arrows'),
    //                 prevArrow:'<button class="arrow-slick3 prev-slick3"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    //                 nextArrow:'<button class="arrow-slick3 next-slick3"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',

    //                 dots: true,
    //                 appendDots: $(this).find('.wrap-slick3-dots'),
    //                 dotsClass:'slick3-dots',
    //                 customPaging: function(slick, index) {
    //                     var portrait = $(slick.$slides[index]).data('thumb');
    //                     return '<img src=" ' + portrait + ' "/><div class="slick3-dot-overlay"></div>';
    //                 },
    //             });
    //         });

    // })(jQuery);

    //     /***********Magnify Popup *********************/
    //   $('.gallery-lb').each(function() { // the containers for all your galleries
    // 			$(this).magnificPopup({
    // 		        delegate: 'a', // the selector for gallery item
    // 		        type: 'image',
    // 		        gallery: {
    // 		        	enabled:true
    // 		        },
    // 		        mainClass: 'mfp-fade'
    // 		    });
    // 		});

    //     })
  },
};
</script>

<style scoped>
@import url("~@/assets/store/css/main.css");
@import url("~@/assets/store/css/util.css");
/* @import url('~@/assets/store/fonts/font-awesome-4.7.0/css/font-awesome.min.css'); */
/* @import url('~@/assets/store/fonts/iconic/css/material-design-iconic-font.min.css'); */
/* @import url('~@/assets/store/fonts/linearicons-v1.0.0/icon-font.min.css'); */
/* @import url('~@/assets/store/vendor/animate/animate.css');
     @import url('~@/assets/store/vendor/css-hamburgers/hamburgers.min.css');
	 @import url('~@/assets/store/vendor/animsition/css/animsition.min.css'); */

@media (max-height: 400px) {
  .m-slide-h {
    height: 230px;
  }
}
@media (max-height: 500px) {
  .m-slide-h {
    height: 340px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/store/StoreNavbar.vue